import { Link } from "react-router-dom";
import logo from "../../../assets/images/tepjf_logo.svg"
import { base_url } from "../../../constants";   
import logo_editorial   from "../../../assets/images/logo_editorial.png";

export default function Iconos_izquierda(){
    return(
        <>
            <a href="https://www.te.gob.mx" className="d-block d-sm-none">
                <img src={logo} id="logoHeader" className="logoHeader1" alt="Tribunal Electoral del Poder Judicial de la Federación" title="Tribunal Electoral del Poder Judicial de la Federación"/>
            </a>
            <div className="container-fluid d-none d-sm-block px-0">
                <div className="row justify-content-center">
                    <div className="col-8 text-end">
                        <Link to={{ pathname: "https://www.te.gob.mx" }} target="_blank" className="mx-2">
                            <img src={logo} id="logoHeader" className="logoHeader" alt="Tribunal Electoral del Poder Judicial de la Federación" title="Tribunal Electoral del Poder Judicial de la Federación" />
                        </Link>
                    </div>
                    <div className="col-4 text-end">
                        <Link to={`/${base_url}/`} className="mx-2">
                            <img src={logo_editorial} id="logoHeader" className="logoHeader" alt="Editorial" title="Editorial" />
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}